import styled, { css } from 'styled-components';
import { MenuItem } from '@mui/material';

import { ToastContainer } from 'react-toastify';

type TypographyVariant = 'h4' | 'h6' | 'body1' | 'body2' | 'caption';

/** styled-components will not interpolate the theme's variant objects, so pull the properties. */
export const typographyVariant = (variant: TypographyVariant) => css`
  font-size: ${({ theme }) => theme.typography[variant].fontSize};
  font-weight: ${({ theme }) => theme.typography[variant].fontWeight};
  line-height: ${({ theme }) => theme.typography[variant].lineHeight};
`;

export const center = css`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ellipsis = css`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const columnFlex = css`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

export const StyledMenuItem = styled(MenuItem)`
  font-size: 1.5rem;
`;

export const StyledToastContainer = styled(ToastContainer)`
  .Toastify__toast {
    align-items: center;
    padding: 6px 16px;
    min-height: 52px;
    min-width: 420px;
  }
  .Toastify__toast-body {
    padding: 0;
    font-family: Roboto;
    font-size: 14px;
    font-weight: 500;
  }
  .Toastify__toast-body > div:last-child {
    margin-right: 12px;
  }
  .Toastify__toast-theme--colored.Toastify__toast--default {
    background-color: rgba(255, 255, 255, 0.9);
    color: ${({ theme }) => theme.toast.success.text};
    .Toastify__close-button > svg {
      fill: ${({ theme }) => theme.toast.success.text};
    }
  }
  .Toastify__toast-theme--colored.Toastify__toast--info {
    background-color: ${({ theme }) => theme.toast.info.background};
    color: ${({ theme }) => theme.toast.info.text};
    .Toastify__close-button > svg {
      fill: ${({ theme }) => theme.toast.info.text};
    }
  }
  .Toastify__toast-theme--colored.Toastify__toast--success {
    background-color: ${({ theme }) => theme.toast.success.background};
    color: ${({ theme }) => theme.toast.success.text};
    .Toastify__close-button > svg {
      fill: ${({ theme }) => theme.toast.success.text};
    }
  }
  .Toastify__toast-theme--colored.Toastify__toast--warning {
    background-color: ${({ theme }) => theme.toast.warning.background};
    color: ${({ theme }) => theme.toast.warning.text};
    .Toastify__close-button > svg {
      fill: ${({ theme }) => theme.toast.warning.text};
    }
  }
  .Toastify__toast-theme--colored.Toastify__toast--error {
    background-color: ${({ theme }) => theme.toast.error.background};
    color: ${({ theme }) => theme.toast.error.text};
    .Toastify__close-button > svg {
      fill: ${({ theme }) => theme.toast.error.text};
    }
  }
`;
